// src/GlobalLayouts/DashboardTemplate.js
import React from 'react';
import { Box, Heading, Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const DashboardTemplate = ({
  title,
  titleColor = 'black',
  tabButtonSize = 'xl',
  tabButtonBg = 'rcBrand.6',
  tabButtonTextColor = 'rcBrand.1',
  tabButtonBorderColor = 'rcBrand.6',
  tabButtonHoverBg = 'transparent',
  tabContentBg = 'gray.50',
  layoutTextColor = 'black',
  tabButtonFontWeight = 'bold',
  leftTabs,
}) => {
  return (
    <Box p={5} minHeight="100vh" color={layoutTextColor}>
      <Heading size="lg" mb={5} color={titleColor}>
        {title}
      </Heading>
      <Box p={4} border ="none" borderWidth="1px" borderRadius="lg" overflow="hidden" >
        <Tabs variant="unstyled">
          <TabList gap={4}>
            {leftTabs.map((tab, index) => (
              <Tab
                key={index}
                borderRadius="full"
                bg="transparent"
                color={tabButtonTextColor}
                border={`1px solid ${tabButtonBorderColor}`}
                _selected={{ bg: tabButtonHoverBg, color: 'rcBrand.1' }}
                _hover={{ bg: tabButtonHoverBg }}
                px={10}
                py={2.5}
                size={tabButtonSize}
                fontWeight={tabButtonFontWeight}
              >
                {tab.label}
              </Tab>
            ))}
          </TabList>
          <TabPanels>
            {leftTabs.map((tab, index) => (
              <TabPanel key={index}>{tab.content}</TabPanel>
            ))}
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
};

DashboardTemplate.propTypes = {
  title: PropTypes.string.isRequired, // Title of the dashboard
  titleColor: PropTypes.string, // Color of the title
  tabButtonSize: PropTypes.oneOf(['sm', 'md', 'lg','xl']), // Size of the tab buttons
  tabButtonBg: PropTypes.string, // Background color of the tab buttons
  tabButtonTextColor: PropTypes.string, // Text color of the tab buttons
  tabButtonBorderColor: PropTypes.string, // Border color of the tab buttons
  tabButtonHoverBg: PropTypes.string, // Background color when hovering over tab buttons
  tabContentBg: PropTypes.string, // Background color of the tab content box
  layoutTextColor: PropTypes.string, // Text color in the layout
  tabButtonFontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // New prop for font weight
  leftTabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired, // Label of the tab button
      content: PropTypes.node.isRequired, // Content inside the tab panel
    })
  ).isRequired,
};

export default DashboardTemplate;
